import React, { useEffect, useState } from "react";
import ComingSoon from "../Common/ComingSoon"
// import { useLocation, useNavigate } from "react-router-dom";
// import Button from "../Common/Button";
// import { Table } from "../Common/Table/Table";
// import SubHeaderMenu from "../Sidebar/SubHeaderMenu";
// import useNetworkServices from "../../Networking/baseAPIManager";
// import { debounce } from "lodash";

const ReferralList = () => {
  // const location = useLocation();
  // const [customerListData, setCustomerListData] = useState([]);
  // const [visibleRows, setVisibleRows] = useState(10);
  // const [filterData, setFilterData] = useState([]);
  // const [offerData, setOfferData] = useState([]);
  // const [filterStatus, setFilterStatus] = useState("");
  // const [isOpen, setIsOpen] = useState(false);
  // const [searchQuery, setSearchQuery] = useState("");

  // console.log(customerListData, "customerListData======>");
  // const { customerList } = useNetworkServices();
  // const navigate = useNavigate();

  // const columns = [
  //   {header: "Customer ID", accessor: "_id" },
  //   {header: "Customer Name", accessor: "name",customTxt:(data)=>{
  //         return<span>{data.fullName}</span>
  //   }},
  //   {header: "Contact No",accessor: "mobile"},
  //   {header: "Email Id",accessor: "email"},
  //   {header: "Loction",accessor: "type"},
  //   {header: "Action",
  //     accessor: "",
  //     customBtn: (data) => {
  //       // console.log("data897897",data)
  //       return (
  //         <Button
  //           type="button"
  //           label="View Detail"
  //           className="text-[#025D89]"
  //           onClick={() => {
  //             setIsOpen(true);
  //             setOfferData(data);
  //           }}
  //         />
  //       );
  //     },
  //   },
  // ];

  // //   const option = [
  // //     { value: "filter", name: "Filter" },
  // //     { value: "Accept", name: "Approved Request" },
  // //     { value: "Pending", name: "Pending Request" },
  // //     { value: "Reject", name: "Reject Request" },
  // //   ];

  // const getCustomerList = async () => {
  //   try {
  //     const response = await customerList();
  //     console.log(response?.data?.data, "response=====>");
  //     setCustomerListData(response?.data?.data);
  //   } catch (error) {
  //     console.error(error, "error");
  //   }
  // };
  // useEffect(() => {
  //   getCustomerList();
  // }, []);

  // const handleSearch = debounce((query) => {
  //   setSearchQuery(query);
  // }, 100);
  // //   useEffect(() => {
  // //     const filteredData =
  // //       filterStatus === "filter" || !filterStatus
  // //         ? customerListData
  // //         : customerListData.filter((item) => item.status === filterStatus);
  // //     setFilterData(filteredData);
  // //   }, [filterStatus, customerListData]);

  // const handleScroll = (event) => {
  //   const { scrollTop, scrollHeight, clientHeight } = event.target;
  //   if (scrollTop + clientHeight >= scrollHeight - 50) {
  //     setVisibleRows((prev) => Math.min(prev + 10, customerListData.length));
  //   }
  // };

  return (
    <div className="w-full">

      <ComingSoon/>
      
      {/* <div className="w-full flex justify-between items-center pe-5 py-5">
        <div className="flex items-center w-1/2">
          <input
            type="text"
            placeholder="Search by customer loction"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>
      </div>
      {/* <div className="w-full flex justify-end items-center pe-5 py-5 ">
        <div className="w-42 h-auto flex justify-between items-center border-[1px] bg-[#025D89] rounded-lg py-1 px-2">
          <MdOutlineFilterAlt className="text-white " />
          <Dropdown
            option={option}
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            SelectClass="bg-[#025D89] text-white outline-none "
          />
        </div>
      </div> */}
      {/* <div */}
        {/* // className="  " // Set a fixed height for scrolling
        // onScroll={handleScroll} */}
      {/* > */}
        {/* <Table columns={columns} data={customerListData} /> */}
      {/* </div> */} 
      
    </div>
  );
};

export default ReferralList;
